export const keepSingleDecimalSeparator = (
  value: string,
  cursorPosition?: number
) => {
  let separatorIndex: number;

  const atCursor =
    cursorPosition != null &&
    cursorPosition > 0 &&
    cursorPosition <= value.length;

  const charBeforeCursor = atCursor ? value[cursorPosition - 1] : '';

  if (charBeforeCursor === ',' || charBeforeCursor === '.') {
    separatorIndex = cursorPosition! - 1;
  } else {
    const lastComma = value.lastIndexOf(',');
    const lastDot = value.lastIndexOf('.');
    separatorIndex = Math.max(lastComma, lastDot);
  }

  if (separatorIndex === -1) {
    return value.replace(/[.,]/g, '');
  }

  const before = value.slice(0, separatorIndex).replace(/[.,]/g, '');
  const after = value.slice(separatorIndex + 1).replace(/[.,]/g, '');
  return `${before},${after}`;
};
